<template>
  <el-form ref="topic" :model="topic" label-width="80px" :span="16" :rules="rules">

    <el-form-item label="题目类型">
      <el-select v-model="topic.type" @change="topicTypeChange">
        <el-option v-for="(type, index) in topicTypeOptions" :key="index" :label="type.label" :value="type.value"></el-option>
      </el-select>
    </el-form-item>

    <el-form-item label="题目名称" prop="name">
      <el-input type="textarea" v-model="topic.name" size="medium" maxlength="255" resize="none" rows="4"></el-input>
    </el-form-item>

    <el-form-item label="题目名称（英文）" prop="nameEn">
      <el-input type="textarea" v-model="topic.nameEn" size="medium" maxlength="255" resize="none" rows="4"></el-input>
    </el-form-item>

    <template v-if="topic.type === 1 || topic.type === 2">
      <el-form-item label="题目选项" required>
        <el-row class="option" gutter="20" type="flex" justify="space-between" v-for="(option, index) in topic.optionList" :key="index">
          <el-col :span="8">
            <el-form-item :prop="'optionList.' + index + '.description'" :rules="option.isOther ? undefined : [
              { type: 'string', required: true, message: '请输入选项描述', trigger: 'blur' },
              { max: 255, message: '不超过255个字符', trigger: 'blur' }
            ]">
              <el-input v-model="option.description" maxlength="255" :disabled="option.isOther" :placeholder="option.isOther ? '其他' : '选项描述' + (index + 1)"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :prop="'optionList.' + index + '.descriptionEn'" :rules="option.isOther ? undefined : [
              { type: 'string', required: true, message: '请输入选项描述（英文）', trigger: 'blur' },
              { max: 255, message: '不超过255个字符', trigger: 'blur' }
            ]">
              <el-input v-model="option.descriptionEn" maxlength="255" :disabled="option.isOther" :placeholder="option.isOther ? 'Other' : '选项描述' + (index + 1) + '（英文）'"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item :prop="'optionList.' + index + '.score'" :rules="option.isOther ? undefined : rules.score">
              <el-input v-if="topic.type === 1" v-model="option.score" maxlength="10" :placeholder="'评分数值' + (index + 1)"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-button type="danger" icon="el-icon-remove-outline" :disabled="topic.optionList.length <= 2" @click="optionDel(index)"></el-button>
            <el-button :disabled="index === 0" type="primary" icon="el-icon-upload2" @click="optionMoveUp(index)"></el-button>
            <el-button :disabled="index === topic.optionList.length - 1" type="primary" icon="el-icon-download" @click="optionMoveDown(index)"></el-button>
          </el-col>
        </el-row>
        <el-button type="primary" size="medium" icon="el-icon-circle-plus-outline" @click="optionAdd(false)">添加</el-button>
        <el-button v-if="topic.type === 1 && !isAlreadyContainOtherOption" type="primary" size="medium" icon="el-icon-circle-plus-outline" @click="optionAdd(true)">添加“其他”选项</el-button>
      </el-form-item>
    </template>

    <el-form-item label="必答题">
      <el-switch v-model="topic.isRequired"></el-switch>
    </el-form-item>

    <template v-if="topic.type === 4">
      <el-form-item label="分数">
        <el-input-number v-model="topic.optionList[0].description" :min="2" :max="10" size="medium" :step="1" @blur="topic.optionList[0].description=parseInt(topic.optionList[0].description)"></el-input-number>
      </el-form-item>
    </template>
  </el-form>
</template>

<script>
import { topicTypeOptions } from '@/const/crud/app/questionnaire';

export default {
    name: 'TopicEditor',
    props: {
      topic: {
        type: Object,
        default: () => ({}),
      }
    },
    data() {
       const validateOptionScore = (rule, value, callback) => {
        if (value) {
          if (/^[0-9]{1,10}$/.test(value)) {
            callback();
          } else {
            callback(new Error('请输入0或正整数'));
          }
        } else {
          callback();
        }
      };
      return {
        currentSelectType: '',
        topicTypeOptions,
        rules: {
          name: [
            { type: 'string', required: true, message: '请输入题目名称', trigger: 'blur' },
            { max: 255, message: '不超过255个字符', trigger: 'blur' },
          ],
          nameEn: [
            { type: 'string', required: true, message: '请输入题目名称（英文）', trigger: 'blur' },
            { max: 255, message: '不超过255个字符', trigger: 'blur' },
          ],
          score: [
            { validator: validateOptionScore, trigger: 'blur' }
          ],
        }
      }
    },
    computed: {
      isAlreadyContainOtherOption() {
        return !!this.topic.optionList.find(option => option.isOther);
      },
    },
    created() {
      this.currentSelectType = this.topic.type;
    },
    methods: {
      optionAdd(isOther) {
        if (isOther && this.isAlreadyContainOtherOption) {
          return;
        }
        const optionList = this.topic.optionList;
        optionList.push({
          description: '',
          type: '',
          sort: '',
          isAnswer: false,
          isOther,
        });
      },
      optionDel(index) {
        const optionList = this.topic.optionList;
        if (optionList.length <= 2) {
          return;
        }
        
        const deletedOptionId = optionList[index].id;
        if (deletedOptionId) {
          const deleteOptionIdList = this.topic.deleteOptionIdList;
          if (!deleteOptionIdList) {
            this.topic.deleteOptionIdList = [deletedOptionId];
          } else {
            this.topic.deleteOptionIdList.push(deletedOptionId);
          }
        }

        optionList.splice(index, 1);
        this.$refs.topic.clearValidate();
      },
      optionMoveUp(index){
        const optionList = this.topic.optionList;
        if (index > 0) {
          optionList[index] = optionList.splice(index - 1, 1, optionList[index])[0];
        }
        this.$refs.topic.clearValidate();
      },
      optionMoveDown(index){
        const optionList = this.topic.optionList;
        if (index < optionList.length - 1) {
          optionList[index] = optionList.splice(index + 1, 1, optionList[index])[0];
        }
        this.$refs.topic.clearValidate();
      },
      setTypeChangeDeleteOptionIdList() {
        this.topic.optionList.forEach(option => {
          if (option.id) {
            if (!this.topic.deleteOptionIdList) {
              this.topic.deleteOptionIdList = [option.id];
            } else {
              this.topic.deleteOptionIdList.push(option.id);
            }
          }
        });
      },
      deleteOtherOption() {
        const optionList = this.topic.optionList;
        for (var i = 0; i < optionList.length; i++) {
          if (optionList[i].isOther) {
            optionList.splice(i, 1);
            i--;
          }
        }
        if (optionList.length < 2) {
          optionList.push({
            description: '',
            type: '',
            sort: '',
            isAnswer: false,
          });
        }
      },
      topicTypeChange(val) {
        switch (val) {
          case 1:
          case 2:
              if (this.currentSelectType === 1 || this.currentSelectType === 2) {
                this.deleteOtherOption();
                break;
              }
              this.setTypeChangeDeleteOptionIdList();
              this.topic.optionList = [
                {
                  description: '',
                  type: '',
                  sort: 1,
                  isAnswer: false,
                },
                {
                  description: '',
                  type: '',
                  sort: 2,
                  isAnswer: false,
                }
              ]
            break;
          case 3:
            this.setTypeChangeDeleteOptionIdList();
            this.topic.optionList = [];
            break;
          case 4:
            this.setTypeChangeDeleteOptionIdList();
            this.topic.optionList = [
              {
                description: '5',
                type: '',
                sort: 1,
                isAnswer: false,
              }
            ]
            break;
        }
        this.currentSelectType = val;
      },
      validate(validator) {
        this.$refs['topic'].validate(validator);
      }
    }
}
</script>

<style lang="scss" scoped>
.option {
  margin-bottom: 12px;
}
</style>